import { MainColor } from '../../palette/colors';

export const getTabTheme = () => {
  return {
    default: {
      border: 'coolGrey30' satisfies MainColor as MainColor,
      title: 'navy95' satisfies MainColor as MainColor,
      label: 'coolGrey60' satisfies MainColor as MainColor,
      tab: {
        default: 'navy80' satisfies MainColor as MainColor,
        selected: 'forest50' satisfies MainColor as MainColor,
        hover: 'navy70' satisfies MainColor as MainColor,
        active: 'navy60' satisfies MainColor as MainColor,
        error: 'red50' satisfies MainColor as MainColor,
      },
    },
  };
};

export type TabTheme = ReturnType<typeof getTabTheme>;
